module.exports = __webpack_public_path__ + "static/media/arrowRightBlue.e67219c7.svg";